var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('multiselect',{attrs:{"options":_vm.automations.data,"custom-label":function (ref) {
    var id = ref.id;
    var type = ref.type;
    var threshold = ref.threshold;
    var condition = ref.condition;
    var name = ref.name;
 
    if (name) {
      return name
    }
    var label = "(" + id + ") " + (_vm.automationTypes[type].name)
    if (_vm.automationTypes[type].threshold(threshold)) {
      label = label + ' / ' + _vm.automationTypes[type].threshold(threshold)
    }
    if (_vm.automationTypes[type].condition(condition)) {
      label = label + ' / ' + _vm.automationTypes[type].condition(condition)
    }
    return label
  },"track-by":"id","value":_vm.selected,"placeholder":"Select Automation"},on:{"input":_vm.handleInput,"remove":_vm.handleRemove},scopedSlots:_vm._u([{key:"option",fn:function(props){return [_c('div',{staticClass:"max-w-full truncate"},[(props.option.name)?[_c('div',[_vm._v(" "+_vm._s(props.option.name)+" ")]),_c('div',{staticClass:"mt-1 text-sm text-gray-500"},[_vm._v(" "+_vm._s(_vm.automationTypes[props.option.type].name)+" ")])]:[_c('div',[_vm._v(" "+_vm._s(_vm.automationTypes[props.option.type].name)+" ")]),_c('div',{staticClass:"mt-1 text-sm text-gray-500"},[(_vm.automationTypes[props.option.type].threshold(props.option.threshold))?_c('span',[_vm._v(" "+_vm._s(_vm.automationTypes[props.option.type].threshold(props.option.threshold))+" ")]):_vm._e(),(_vm.automationTypes[props.option.type].condition(props.option.condition))?_c('span',[_vm._v(" "+_vm._s(_vm.automationTypes[props.option.type].condition(props.option.condition))+" ")]):_vm._e()])]],2)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }